import React, { useContext, useState } from 'react';
import { DropResult } from 'react-beautiful-dnd';

import ScorecardContext from 'contexts/ScorecardContext';
import AccountPickerContext from 'contexts/AccountPickerContext';
import STORE from 'store';
import isDefined from 'isDefined';

import QuickFilters from '../../CustomerLaneCommitsBoard/Settings/QuickFilters/QuickFilters';
import NewScorecardQuickFilterForm from './NewScorecardQuickFilterForm';

const ScorecardQuickFiltersSettings = ({ close }: { close: () => void }) => {
  const { selectedAccountId } = useContext(AccountPickerContext);
  const { scorecard, updateScorecard, quickFilters } =
    useContext(ScorecardContext);
  const quickFilterOrder = scorecard.quickFilterOrder || [];
  const [isCreatingNewFilter, setIsCreatingNewFilter] =
    useState<boolean>(false);

  // quickFilterOrder may reference IDs for filters that have since been deleted.
  // Filter those out, then append any filters missing from the order array at the end.
  const orderedFilters = quickFilterOrder
    .map((filterId) => quickFilters.find((f) => f.id === filterId))
    .filter(isDefined);
  const filtersNotInOrder = quickFilters.filter(
    (f) => !quickFilterOrder.includes(f.id),
  );
  orderedFilters.push(...filtersNotInOrder);

  const onDragEnd = (result: DropResult) => {
    const { draggableId, destination } = result;
    if (!destination) {
      return;
    }

    const itemsWithoutDropped = orderedFilters.filter(
      (f) => f.id !== draggableId,
    );

    const newOrder = [
      ...itemsWithoutDropped.slice(0, destination.index).map((f) => f.id),
      draggableId,
      ...itemsWithoutDropped
        .slice(destination.index, itemsWithoutDropped.length)
        .map((f) => f.id),
    ];

    updateScorecard({ ...scorecard, quickFilterOrder: newOrder });
  };

  const deleteFilter = (f: LegacySavedFilter) => {
    STORE.filterDefinitions
      .getLegacySavedFiltersRef({ accountId: selectedAccountId })
      .doc(f.id)
      .delete()
      .then(() => {
        updateScorecard({
          ...scorecard,
          quickFilterOrder: quickFilterOrder.filter((fid) => fid !== f.id),
        });
      });
  };

  if (isCreatingNewFilter) {
    return (
      <NewScorecardQuickFilterForm
        close={() => setIsCreatingNewFilter(false)}
      />
    );
  }

  return (
    <QuickFilters
      isCreatingNewFilter={isCreatingNewFilter}
      setIsCreatingNewFilter={setIsCreatingNewFilter}
      orderedFilters={orderedFilters}
      onDragEnd={onDragEnd}
      deleteFilter={deleteFilter}
      close={close}
    />
  );
};

export default ScorecardQuickFiltersSettings;
